import { ERP } from '../_base/endpoint';
import axios from 'axios';

import global from '../../common/utility/global';

class unidadmedidaService {

    /******* QUERIES ******/
    
    async listar() {
        const response = await axios
            .get(`${ERP}administracion/unidad-medida`)
            .then(response => { 
                return response.data; 
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async listarGRE() {
        const response = await axios
            .get(`${ERP}administracion/unidad-medida/sunat-gre`)
            .then(response => { 
                return response.data; 
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async listarSunat() {
        const response = await axios
            .get(`${ERP}administracion/unidad-medida/sunat`)
            .then(response => { 
                return response.data; 
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async paginacion(filter) {
        const response = await axios
            .get(`${ERP}administracion/unidad-medida/paginacion?${global.formatParameter(filter)}`)
            .then(response => { 
                return response.data; 
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async obtenerPorId(id) {
        const response = await axios
            .get(`${ERP}administracion/unidad-medida/${id}`)
            .then(response => { 
                return response.data; 
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async excel(filter) {
        const response = await axios
            .get(`${ERP}administracion/unidad-medida/excel?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async pdf(filter) {
        const response = await axios
            .get(`${ERP}administracion/unidad-medida/pdf?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    /******* TRANSACCIONES ******/

    async registrar(data) {
        const response = await axios
            .post(`${ERP}administracion/unidad-medida`, data)
            .then(response => { 
                return response; 
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

    async modificar(data) {
        const response = await axios
            .put(`${ERP}administracion/unidad-medida`, data)
            .then(response => { 
                return response; 
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

    async eliminar(data) {
        const response = await axios
            .put(`${ERP}administracion/unidad-medida/eliminar`, data)
            .then(response => { 
                return response; 
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

    async activar(data) {
        const response = await axios
            .put(`${ERP}administracion/unidad-medida/activar`, data)
            .then(response => { 
                return response; 
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };
}

export default new unidadmedidaService();